class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.closeTimers = new Map();
  }

  connectedCallback() {
    if (!this.closest('.header__inline-menu') || this.hoverEvents) return;
    this.hoverEvents = new AbortController();
    const options = { signal: this.hoverEvents.signal };
    this.querySelectorAll('details').forEach((details) => {
      details.addEventListener('pointerenter', (event) => this.openOnHover(event, details), options);
      details.addEventListener('pointerleave', (event) => this.closeAfterHover(event, details), options);
      details.addEventListener('toggle', () => {
        details.querySelector(':scope > summary').setAttribute('aria-expanded', String(details.open));
      }, options);
    });
    this.hoverQuery.addEventListener('change', () => {
      if (!this.hoverQuery.matches) this.close();
    }, options);
  }

  disconnectedCallback() {
    this.hoverEvents?.abort();
    this.hoverEvents = null;
    this.closeTimers.forEach((timer) => window.clearTimeout(timer));
    this.closeTimers.clear();
  }

  openOnHover(event, details) {
    if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
    window.clearTimeout(this.closeTimers.get(details));
    this.closeTimers.delete(details);
    if (details === this.mainDetailsToggle) {
      this.closest('.header__inline-menu').querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
    } else {
      details.parentElement.parentElement.querySelectorAll(':scope > li > details').forEach((sibling) => {
        if (sibling !== details) this.closeDetails(sibling);
      });
    }
    details.open = true;
    details.querySelector(':scope > summary').setAttribute('aria-expanded', 'true');
  }

  closeAfterHover(event, details) {
    if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
    window.clearTimeout(this.closeTimers.get(details));
    this.closeTimers.set(details, window.setTimeout(() => {
      this.closeTimers.delete(details);
      if (details.matches(':hover')) return;
      const focused = document.activeElement;
      if (details.contains(focused) && focused.matches(':focus-visible')) return;
      this.closeDetails(details);
    }, 200));
  }

  closeDetails(details) {
    [details, ...details.querySelectorAll('details')].forEach((item) => {
      window.clearTimeout(this.closeTimers.get(item));
      this.closeTimers.delete(item);
      item.open = false;
      item.querySelector(':scope > summary').setAttribute('aria-expanded', 'false');
    });
  }

  close() {
    this.closeDetails(this.mainDetailsToggle);
  }

  onFocusOut() {
    window.setTimeout(() => {
      if (this.hoverQuery.matches && this.matches(':hover')) return;
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    const navigation = this.closest('.header__inline-menu');
    this.header.preventHide = navigation
      ? Boolean(navigation.querySelector('header-menu > details[open]'))
      : this.mainDetailsToggle.open;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
